import React from 'react'
import { Modal as RModal } from "react-responsive-modal";
import "react-responsive-modal/styles.css";
import { AbstructVar } from '../../general/general-component/abstruct-component/AbstructVar';
import './Calendar.css'
import BodyCalendar from './BodyCalendar';

function Calendar({ open, setOpen }) {
    let { mode, dispatch, langLocal } = AbstructVar()
    return (
        <RModal
            open={open}
            onClose={() => {
                setOpen(false);
            }}
            center
            classNames={{
                modal: `popupR`,
                closeButton: 'customCloseButton'
            }}
            focusTrapped={false}
            overlayOpacity={0.5}
        >
            <div className={`div_popup ${mode === 'dark' ? "darkPopUp" : "lightPopUp"}`}>
                <div style={{ marginTop: "20px" }} >
                    <BodyCalendar />
                </div>
            </div>
        </RModal>
    )
}

export default Calendar